var GameTxType = /* @__PURE__ */ ((GameTxType2) => {
  GameTxType2["Uncategorized"] = "uncategorized";
  return GameTxType2;
})(GameTxType || {});
var FundingTxPayDataType = /* @__PURE__ */ ((FundingTxPayDataType2) => {
  FundingTxPayDataType2["NATIVE"] = "native";
  FundingTxPayDataType2["REDIRECT"] = "redirect";
  FundingTxPayDataType2["NEW_WINDOW"] = "new-window";
  FundingTxPayDataType2["QR_NATIVE"] = "qr-native";
  return FundingTxPayDataType2;
})(FundingTxPayDataType || {});
var FundingStatus = /* @__PURE__ */ ((FundingStatus2) => {
  FundingStatus2["Pending"] = "pending";
  FundingStatus2["Processing"] = "processing";
  FundingStatus2["PendingAudit"] = "pending-audit";
  FundingStatus2["Completed"] = "completed";
  FundingStatus2["Error"] = "error";
  FundingStatus2["Timeout"] = "timeout";
  FundingStatus2["Cancelled"] = "cancelled";
  FundingStatus2["PendingProof"] = "pending-proof";
  return FundingStatus2;
})(FundingStatus || {});
var FundingType = /* @__PURE__ */ ((FundingType2) => {
  FundingType2["Deposit"] = "deposit";
  FundingType2["Withdraw"] = "withdraw";
  FundingType2["Adjustment"] = "adjustment";
  FundingType2["Transfer"] = "transfer";
  FundingType2["Promotion"] = "promotion";
  FundingType2["Turnover"] = "turnover";
  FundingType2["CreditLoss"] = "credit-loss";
  FundingType2["Commission"] = "commission";
  return FundingType2;
})(FundingType || {});
export {
  FundingStatus,
  FundingTxPayDataType,
  FundingType,
  GameTxType
};
